module.exports = __webpack_public_path__ + "img/1666234386842-Desert.jpg.0cfa21c4.webp";